import { render, staticRenderFns } from "./Main-column.vue?vue&type=template&id=127d9862"
import script from "./Main-column.vue?vue&type=script&lang=js"
export * from "./Main-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports